import React, { FC } from "react";

const circleClose: FC = () => {
    return (
        <svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0 12.5C0 5.59644 5.59644 0 12.5 0C19.4036 0 25 5.59644 25 12.5C25 19.4036 19.4036 25 12.5 25C5.59644 25 0 19.4036 0 12.5Z"
                fill="#ABABAB"
            />
            <path
                d="M17.4461 8.66179C17.752 8.35586 17.752 7.85985 17.4461 7.55393C17.1401 7.248 16.6441 7.248 16.3382 7.55393L12.5 11.3921L8.66179 7.55393C8.35586 7.248 7.85985 7.248 7.55393 7.55393C7.248 7.85985 7.248 8.35586 7.55393 8.66179L11.3921 12.5L7.55393 16.3382C7.248 16.6441 7.248 17.1401 7.55393 17.4461C7.85985 17.752 8.35586 17.752 8.66179 17.4461L12.5 13.6079L16.3382 17.4461C16.6441 17.752 17.1401 17.752 17.4461 17.4461C17.752 17.1401 17.752 16.6441 17.4461 16.3382L13.6079 12.5L17.4461 8.66179Z"
                fill="white"
            />
        </svg>
    );
};

export default React.memo(circleClose);
